module.exports = __webpack_public_path__ + "img/join3-5-h.6610d831.png";